// this is a function so it is easy to mock
export const isBrowser = () => {
  return typeof window !== 'undefined';
};
